// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n0-0";
export var assigneeDetails = "_n0-1";
export var assigneeInfo = "_n0-2";
export var dropdownContainer = "_n0-4";
export var dropdownImage = "_n0-5";
export var editAssigneeInfo = "_n0-3";
export var editAssigneeModalContainer = "_n0-6";
export var hidden = "_n0-8";
export var input = "_n0-7";